class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


document.addEventListener("DOMContentLoaded", function () {
  var menuContainer = document.querySelector(".header__inline-menu");
  if (menuContainer) {
    var primaryMenuLinks = menuContainer.querySelectorAll("details.mega-menu");
    primaryMenuLinks.forEach(function (link) {
      var megaMenu = link.querySelector(".mega-menu__content");
      if (megaMenu) {
        var menuTimer;
        var isMouseOverMegaMenu = false; // 新增变量，用于跟踪鼠标是否在二级菜单上

        link.addEventListener("mouseover", function () {
          clearTimeout(menuTimer);
          menuTimer = setTimeout(function () {
            link.setAttribute("open", "");
            isMouseOverMegaMenu = false; // 当一级菜单被鼠标覆盖时，重置标志位
          }, 300);
        });

        link.addEventListener("mouseout", function () {
          clearTimeout(menuTimer);
          // 只有当二级菜单没有鼠标覆盖时，才设置关闭菜单的定时器
          if (!isMouseOverMegaMenu) {
            menuTimer = setTimeout(function () {
              link.removeAttribute("open");
            }, 300);
          }
        });

        megaMenu.addEventListener("mouseover", function () {
          clearTimeout(menuTimer);
          isMouseOverMegaMenu = true; // 当鼠标移动到二级菜单时，设置标志位
          link.setAttribute("open", "");
        });

        megaMenu.addEventListener("mouseout", function (event) {
          if (!link.contains(event.relatedTarget)) {
            isMouseOverMegaMenu = false; // 当鼠标离开二级菜单时，重置标志位
            // 由于一级菜单的mouseout事件也会被触发，我们在这里不直接关闭菜单
            // 而是设置一个定时器，等待300ms后关闭
            menuTimer = setTimeout(function () {
              if (!isMouseOverMegaMenu) {
                link.removeAttribute("open");
              }
            }, 300);
          }
        });
      }
    });
  }
});